import { m } from '../i18n';
import { sfx } from '../audio/sfx';
import { saveSettings, settings } from '../core/settings';
import { h } from './dom';
import { layers } from './layers';

/** What each tutorial step points at (null = centred card, no spotlight). */
const TARGETS: readonly (string | null)[] = [null, '#dpad', '#ctxBtn', '#jumpBtn', '#taskBar', '#btnJournal', '#btnPhone', '#btnMenu'];

let root: HTMLElement | null = null;

export function tutorialSeen(): boolean {
  return !!settings.tutorialDone;
}

/** A short guided tour: dims the screen and spotlights one control per step. */
export function openTutorial(): void {
  if (root) return;
  let i = 0;
  layers.open('tutorial');
  root = h('div', { class: 'tut', role: 'dialog', 'aria-modal': 'true' });
  document.getElementById('wrap')!.append(root);

  const finish = () => {
    settings.tutorialDone = true;
    saveSettings();
    root?.remove();
    root = null;
    layers.close('tutorial');
  };

  const render = () => {
    const t = m().tutorial;
    const step = t.steps[i];
    const sel = TARGETS[i];
    const el = sel ? document.querySelector<HTMLElement>(sel) : null;
    const wrap = document.getElementById('wrap')!.getBoundingClientRect();
    const r = el?.getBoundingClientRect();
    const pad = 6;
    const spot = r
      ? h('div', { class: 'tut-spot', style: `left:${r.left - wrap.left - pad}px; top:${r.top - wrap.top - pad}px; width:${r.width + pad * 2}px; height:${r.height + pad * 2}px` })
      : h('div', { class: 'tut-spot none' });
    // Put the card on the side of the screen away from the highlighted control.
    const below = !r || r.top + r.height / 2 < wrap.top + wrap.height / 2;
    const last = i === t.steps.length - 1;
    const card = h(
      'div',
      { class: `tut-card ${r ? (below ? 'below' : 'above') : 'center'}`, style: r ? (below ? `top:${r.bottom - wrap.top + 16}px` : `bottom:${wrap.bottom - r.top + 16}px`) : '' },
      h('div', { class: 'tut-dots' }, t.steps.map((_, k) => h('i', { class: k === i ? 'on' : '' }))),
      h('b', null, step.title),
      h('p', null, step.text),
      h(
        'div',
        { class: 'tut-actions' },
        last ? null : h('button', { class: 'btn ghost', onclick: () => (sfx('click'), finish()) }, t.skip),
        i > 0 ? h('button', { class: 'btn', onclick: () => (sfx('click'), i--, render()) }, t.back) : null,
        h('button', { class: 'btn gold', onclick: () => (sfx('click'), last ? finish() : (i++, render())) }, last ? t.done : t.next),
      ),
    );
    root!.replaceChildren(spot, card);
  };
  render();
  window.addEventListener('resize', () => root && render(), { once: true });
}
